import { ImagePlus, Trash2 } from "lucide-react";
import { useState } from "react";
import { API } from "../../data/siteData";

function getUploadError(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || "Invalid rendering upload.").join(" ");
  return "The rendering could not be uploaded. Use PNG, JPEG, or WebP under 20 MB.";
}

export default function RenderingManager({ renderings, onRefresh }) {
  const [state, setState] = useState("idle");
  const [message, setMessage] = useState("");
  const [deletingId, setDeletingId] = useState("");

  const upload = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setState("loading");
    setMessage("");
    try {
      const response = await fetch(`${API}/admin/renderings`, {
        method: "POST",
        credentials: "include",
        body: new FormData(form),
      });
      const body = await response.json();
      if (!response.ok) throw new Error(getUploadError(body.detail));
      form.reset();
      setState("success");
      setMessage("Conceptual rendering added to the investor gallery.");
      await onRefresh();
    } catch (uploadError) {
      setState("error");
      setMessage(uploadError.message);
    }
  };

  const remove = async (rendering) => {
    if (!window.confirm(`Remove “${rendering.title}” from the investor gallery?`)) return;
    setDeletingId(rendering.rendering_id);
    try {
      const response = await fetch(`${API}/admin/renderings/${rendering.rendering_id}`, {
        method: "DELETE",
        credentials: "include",
      });
      if (!response.ok) throw new Error();
      await onRefresh();
    } finally {
      setDeletingId("");
    }
  };

  return <section className="admin-section" data-testid="admin-rendering-manager"><div><span className="eyebrow">Approved investor visual materials</span><h2>CONCEPTUAL RENDERINGS</h2></div><div className="content-manager-grid"><div className="admin-record-list" data-testid="admin-rendering-list">{!renderings.length && <div className="empty-state" data-testid="admin-renderings-empty-state">No conceptual renderings are published yet.</div>}{renderings.map((rendering) => <article key={rendering.rendering_id} data-testid={`admin-rendering-${rendering.rendering_id}`}><div><span>{rendering.content_type.replace("image/", "")}</span><h3>{rendering.title}</h3><p>{rendering.filename}</p></div><button className="icon-button document-delete-button" type="button" title="Remove rendering" disabled={deletingId === rendering.rendering_id} onClick={() => remove(rendering)} data-testid={`delete-rendering-${rendering.rendering_id}`}><Trash2 size={16} /></button></article>)}</div><form className="admin-editor-form" onSubmit={upload} data-testid="rendering-upload-form"><label>Rendering title<input required name="title" data-testid="rendering-title-input" /></label><label>Caption<textarea required name="caption" data-testid="rendering-caption-input" /></label><label>Accessible image description<input required name="alt_text" data-testid="rendering-alt-text-input" /></label><label>Image file<input required type="file" accept="image/png,image/jpeg,image/webp" name="file" data-testid="rendering-file-input" /></label>{message && <p className={state === "error" ? "form-error" : "upload-message"} data-testid="rendering-upload-message">{message}</p>}<button className="button button--red" disabled={state === "loading"} data-testid="rendering-upload-submit-button"><ImagePlus size={16} />{state === "loading" ? "Uploading…" : "Upload rendering"}</button></form></div></section>;
}